import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import CurrentPage from '@frontend/app/features/CurrentPage';
import WindowEnv from '@frontend/app/features/WindowEnv';
import { init, track } from '@plausible-analytics/tracker'
import MatomoTracker from '@frontend/app/features/MatomoTracker';

export default class extends Controller {
  connect() {
    const goals = window.ENV.userGoals;
    if (goals.length === 0) return;
    init({
      domain: WindowEnv.defaultHost(),
    })

    goals.forEach((goal) => {
      switch (goal.system) {
        case 'plausible':
          track(goal.identifier, {
            callback: (result) => {
              if (result?.status) {
                this.markGoalProcessed(goal.id)
              }
            }
          });
          break;
        case 'matomo':
          MatomoTracker.trackGoal(Number.parseInt(goal.identifier));
          this.markGoalProcessed(goal.id);
          break;
      }
    });
  }

  markGoalProcessed(goalId) {
    patch(
      CurrentPage.getUserGoalMarkTrackedActionPath().replace(
        ':user_goal_id',
        goalId
      )
    );
  }
}
